import moment from 'moment'
import { InstallationPowerPriceDto } from '../../../installation/api/power-prices'
import { WallboxHistoryDatumDto } from '../../Dashboard/Charts/api/wallbox-history-data'

function findStaticPrice(wbTime: number, tariffs: Nullable<InstallationPowerPriceDto>[] | undefined): number {
  if (!tariffs) {
    return 0
  }

  const inputMoment = moment.utc(wbTime).local()
  const inputWeekday = inputMoment.isoWeekday() % 7
  const inputTime = inputMoment.format('HH:mm')

  const validTariffs = tariffs.filter(tariff => {
    const tariffStart = tariff.start ? moment.utc(tariff.start).valueOf() : -Infinity
    const tariffEnd = tariff.end ? moment.utc(tariff.end).valueOf() : Infinity
    return wbTime >= tariffStart && wbTime <= tariffEnd
  })

  const weekdayFilteredTariffs = validTariffs.filter(tariff => tariff?.weekday?.split(',').map(Number).includes(inputWeekday))

  const matchingTariffs = weekdayFilteredTariffs.filter(tariff => {
    const tariffFromTime = moment.utc(tariff.from, 'HH:mm')
    const inputMomentTime = moment.utc(inputTime, 'HH:mm')
    return inputMomentTime.isSameOrAfter(tariffFromTime)
  })

  if (matchingTariffs.length === 0) {
    return 0
  }

  const bestTariff = matchingTariffs.reduce((prev, current) => {
    const prevFromTime = moment.utc(prev.from, 'HH:mm')
    const currentFromTime = moment.utc(current.from, 'HH:mm')
    return prevFromTime.isAfter(currentFromTime) ? prev : current
  })

  return Number(bestTariff.price)
}

export const calculateStaticSessionCostWithCurrency = (
  wallboxData: WallboxHistoryDatumDto[],
  tariffs: Nullable<InstallationPowerPriceDto>[] | undefined,
  currentCurrency: string
): string => {
  const totalPrice = wallboxData.reduce<number>((total, wallboxDatum) => {
    const currentPrice = findStaticPrice(wallboxDatum.time, tariffs)
    const gridConsumption = Math.max(0, Number(wallboxDatum.energyAll) - Number(wallboxDatum.energySolar))

    const totalConsumption = gridConsumption ? gridConsumption / 1000 : 0
    const currentTotalPrice = totalConsumption * currentPrice
    return total + currentTotalPrice
  }, 0)

  const totalPossitivePrice = Math.max(totalPrice, 0)

  return formatPrice(currentCurrency, totalPossitivePrice)
}

export function formatPrice(currentCurrency: string, price: number): string {
  return Intl.NumberFormat(window.navigator.language, {
    style: 'currency',
    currency: currentCurrency,
  }).format(price)
}
